export default {
  authenticatedUser: state => {
    // Return True if there is a authenticated user in the app. False otherwise
    return state.username !== null
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js